var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { apolloSpaceInlineHalfX } from "@nexthink/apollo-tokens";
import Icon from "../icons/Icon";
export const StyledIndicator = styled(Icon).withConfig({ displayName: "StyledIndicator_APC-7311-productShell", componentId: "sc-1523w8x" })(({ theme }) => ({
    maxHeight: "6px",
    maxWidth: "6px",
    marginLeft: apolloSpaceInlineHalfX,
    color: theme.colors.apolloColorTextError,
    verticalAlign: "middle",
}));
const Indicator = (_a) => {
    var { indicator } = _a, rest = __rest(_a, ["indicator"]);
    return indicator ? React.createElement(StyledIndicator, Object.assign({ name: "dot" }, rest)) : null;
};
export default Indicator;
//# sourceMappingURL=Indicator.js.map